import React, { useEffect, useRef, useState } from "react";
// import ContractSummaryPdf from "../../../components/contractSummary";
import { getContractDetails } from "../../../services/ContractApi";
import { useParams } from "react-router-dom";
import { handleOpenSnackBar } from "../../../utils/helper";
import AppHeader from "../../../components/header";
import ContractSummaryPdf from "../../../components/contractSummary";
import GlobalButton from "../../../components/button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Box, Grid, Stack, Typography } from "@mui/material";
import AppLoader from "../../../components/loader";
import TextInput from "../../../components/textInput";
import Label from "../../../components/label";

const ConnectionDetails = () => {
  const { id } = useParams();
  const pdfRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const generalInfo = details?.generalInfo;
  const eBillingAddress = details?.eBillingAddress;
  const debitDetails = details?.debitDetails;

  useEffect(() => {
    if (id) {
      fetchContractsDetails(id);
    }
  }, [id]);

  const fetchContractsDetails = async (id) => {
    try {
      setIsLoading(true);
      const response = await getContractDetails(id);
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setDetails(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = () => {
    setIsLoading(true);
    const input = pdfRef.current;
    
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
      heightLeft -= pdfHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight; // Move position to the next page
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
      }

      pdf.save("contract-summary.pdf");
      setIsLoading(false);
    });
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />

      <Stack alignItems={"center"} textAlign={"center"} spacing={0.5}>
        <Typography
          variant="primaryText"
          component={"h1"}
          fontSize={{ xs: "1.5rem", md: "2.125rem" }}
        >
          Connection Details
        </Typography>
      </Stack>

      {/* General Information */}
      <Box my={2}>
        <Typography variant="h6" color={"text.charcoalGrey"}>
          General Information
        </Typography>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Agent"} />
            <TextInput variant={"filled"} value={generalInfo?.agent} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Agent"} />
            <TextInput variant={"filled"} value={generalInfo?.agent} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Customer Name"} />
            <TextInput variant={"filled"} value={generalInfo?.name} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Customer’s Designation/s"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.designation}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Title"} />
            <TextInput variant={"filled"} value={generalInfo?.title} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Customer Email"} />
            <TextInput variant={"filled"} value={generalInfo?.email} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Mobile number"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.mobileNo}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Town"} />
            <TextInput variant={"filled"} value={generalInfo?.town} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"City"} />
            <TextInput variant={"filled"} value={generalInfo?.city} readonly />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Post code"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.postCode}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Business name"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.businessName}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Business type"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.businessType}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Label title={"1st line of phone number address"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.address1}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Label title={"2nd line of phone number address"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.address2}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Billing Email"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.billingEmail}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"E-Billing"} />
            <TextInput
              variant={"filled"}
              value={generalInfo?.eBilling}
              readonly
            />
          </Grid>
        </Grid>
      </Box>

      {generalInfo?.eBilling === "No" && <Box my={2}>
        <Typography variant="h6" color={"text.charcoalGrey"}>
          E-Billing Another Address
        </Typography>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Town"} />
            <TextInput
              variant={"filled"}
              value={eBillingAddress?.town}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"City"} />
            <TextInput
              variant={"filled"}
              value={eBillingAddress?.city}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Label title={"Post code"} />
            <TextInput
              variant={"filled"}
              value={eBillingAddress?.postCode}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Label title={"1st line of phone number address"} />
            <TextInput
              variant={"filled"}
              value={eBillingAddress?.address1}
              readonly
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Label title={"2nd line of phone number address"} />
            <TextInput
              variant={"filled"}
              value={eBillingAddress?.address2}
              readonly
            />
          </Grid>
        </Grid>
      </Box>}
      
      {details?.isDebitDetails && (
        <Box my={2}>
          <Typography variant="h6" color={"text.charcoalGrey"}>
            Direct Debit Details
          </Typography>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Label title={"Name of Account Holder"} />
              <TextInput
                variant={"filled"}
                value={debitDetails?.username}
                readonly
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Label title={"Account Number (8 digits)"} />
              <TextInput
                variant={"filled"}
                value={debitDetails?.accountNumber}
                readonly
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Label title={"Short Code"} />
              <TextInput
                variant={"filled"}
                value={debitDetails?.shortCode}
                readonly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Label title={"Name and Address of Bank/Building Society"} />
              <TextInput
                variant={"filled"}
                value={debitDetails?.address}
                readonly
              />
            </Grid>
          </Grid>
        </Box>
      )}



      {details && (
        <Box p={2} ref={pdfRef}>
          {" "}
          <ContractSummaryPdf row={details} />{" "}
        </Box>
      )}
      <GlobalButton
        variant={"custom_gradient"}
        title={"Download"}
        style={{ mt: 1, ml: "auto", width: 150 }}
        handleClickBtn={handleDownloadPdf}
      />
    </AppHeader>
  );
};

export default ConnectionDetails;
